import { useEffect, useState, ReactNode, FC } from 'react';
import { IntlProvider as BaseIntlProvider } from 'react-intl';
import { useRecoilValue } from 'recoil';

import en from './lang/en.json';
import es from './lang/es.json';
import { localeState } from './state/atoms/localeAtoms';

export type Messages = {
    [key: string]: string;
};
const messages: Record<string, Messages> = {
    en,
    es,
};

export const IntlProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const stateLocale = useRecoilValue(localeState);
    const locale = Object.keys(messages).includes(stateLocale)
        ? stateLocale
        : 'en';
    const [intlMessages, setIntlMessages] = useState(messages[locale]);

    useEffect(() => {
        setIntlMessages(messages[locale]);
    }, [locale]);

    return (
        <BaseIntlProvider locale={locale} messages={intlMessages}>
            {children}
        </BaseIntlProvider>
    );
};
